<div *ngIf="!invoice">No Invoice found please contact RAF...</div>
<div class="container">
    <div class="row">
        <div *ngIf="invoice" class="col-md-{{ invoice?.paid ? '12' : '8' }} my-3">
            <div class="card" width="100%">
                <div class="card-body">
                    <div class="d-flex flex-fill" style="border-bottom: 1px solid;">
                        <div *ngIf="invoice?.paid" class="invoice-box">
                            Invoice <span>Paid - {{ invoice?.paid | date : 'MM/dd/yyyy' }}</span>
                        </div>
                        <div class="invoice-title ml-auto">
                            <h3 class="ml-auto">Invoice # {{ invoice?.invoiceNumber }}</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <address>
                                <strong>Bill To</strong><br />
                                {{ invoice?.billingAddress1 }}
                                <span *ngIf="invoice?.billingAddress2"><br />{{ invoice?.billingAddress2 }}</span
                                ><br />
                                {{ invoice?.billingCity + ', ' + invoice?.billingState + ' ' + invoice?.billingZip }}
                            </address>
                        </div>
                        <div class="col-md-6 text-right">
                            <address>
                                <strong>Date</strong><br />
                                {{ invoice?.created | date : 'MM/dd/yyyy' }}<br /><br />
                            </address>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <strong>Terms</strong><br />
                            Net 30<br /><br />
                        </div>
                        <div class="col-md-6 text-right">
                            <strong>Description</strong><br />
                            {{ invoice?.description }}<br /><br />
                        </div>
                    </div>

                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h3 class="panel-title" style="color: #333"><strong>Order Summary</strong></h3>
                        </div>
                        <div class="panel-body">
                            <div class="table-responsive">
                                <table class="invoice-table table table-condensed">
                                    <thead>
                                        <tr>
                                            <td><strong>Item</strong></td>
                                            <td class="text-center"><strong>Description</strong></td>
                                            <td class="text-center"><strong>Price</strong></td>
                                            <td class="text-center"><strong>Quantity</strong></td>
                                            <td class="text-right"><strong>Total</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let line of invoice?.invoiceLines">
                                            <tr>
                                                <td>{{ line.item }}</td>
                                                <td class="text-center">{{ line.description }}</td>
                                                <td class="text-center">{{ line.price | currency }}</td>
                                                <td class="text-center">{{ !!line.quantity || line.quantity !== 0 ? line.quantity : '---' }}</td>
                                                <td class="text-right">
                                                    {{ !!line.quantity || line.quantity !== 0 ? (line.price * line.quantity | currency) : (line.price | currency) }}
                                                </td>
                                            </tr>
                                        </ng-container>
                                        <tr>
                                            <td class="thick-line"></td>
                                            <td class="thick-line"></td>
                                            <td class="thick-line"></td>
                                            <td class="thick-line text-right"><strong>Subtotal</strong></td>
                                            <td class="thick-line text-right">{{ subTotal | currency }}</td>
                                        </tr>
                                        <tr>
                                            <td class="thick-line"></td>
                                            <td class="thick-line"></td>
                                            <td class="thick-line"></td>
                                            <td class="thick-line text-right"><strong>Processing Fee</strong></td>
                                            <td class="thick-line text-right">{{ invoice.processingFee | currency }}</td>
                                        </tr>
                                        <!-- <tr>
                                            <td class="no-line"></td>
                                            <td class="no-line"></td>
                                            <td class="no-line"></td>
                                            <td class="no-line text-center"><strong>Tax</strong></td>
                                            <td class="no-line text-right">{{ invoice.tax | currency }}</td>
                                        </tr> -->
                                        <tr>
                                            <td class="no-line"></td>
                                            <td class="no-line"></td>
                                            <td class="no-line"></td>
                                            <td class="no-line"></td>
                                            <td class="no-line"></td>
                                        </tr>
                                        <tr>
                                            <td class="no-line"></td>
                                            <td class="no-line"></td>
                                            <td class="no-line"></td>
                                            <td class="no-line text-right"><strong>Total</strong></td>
                                            <td class="no-line text-right">{{ invoice.total + invoice.processingFee | currency }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-4 my-3" *ngIf="!invoice?.paid">
            <div class="card" width="100%">
                <div class="card-header billing-payment-title">Payment</div>
                <div class="card-body">
                    <form #customForm="ngForm">
                        <div class="form-row">
                            <div class="col-md-12 form-group">
                                <label class="control-label">Name on Card*</label>
                                <input class="form-control" type="text" name="name" [(ngModel)]="nameOnCard" required />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12 form-group">
                                <label class="control-label">Email*</label>
                                <input class="form-control" type="text" name="email" [(ngModel)]="email" required />
                            </div>
                        </div>
                        <!-- <div class="form-row">
                            <div class="col-md-12 form-group">
                                <label class="control-label">Card Number*</label>
                                <input class="form-control" type="string" name="cardNumber" [(ngModel)]="cardNumber" required />
                            </div>
                        </div> -->
                        <!-- <div class="form-row">
                            <div class="col-md-4 form-group">
                                <label class="control-label">CVC*</label>
                                <input class="form-control card-cvc" type="string" name="securityCode" [(ngModel)]="cvc" required />
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="control-label">Expiration*</label>
                                <select class="form-control" name="expirationMonth" [(ngModel)]="expirationMonth" required>
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="control-label"> </label>
                                <select class="form-control" name="expirationMonth" [(ngModel)]="expirationYear" required>
                                    <ng-container *ngFor="let year of expirationYears">
                                        <option value="{{ year }}">{{ year }}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </div> -->
                        <div class="form-row">
                            <div class="col-md-12 payment-total">
                                Total
                                {{ invoice?.total + invoice?.processingFee | currency }}
                            </div>
                        </div>

                        <div class="form-row card p-3">
                            <!-- <div class="card"> -->
                            <label>
                                <!-- placeholder for Elements -->
                                <div id="payment-element" class="field"></div>
                            </label>
                            <!-- <button type="submit" (click)="payment()">Submit Payment</button> -->
                            <!-- </div> -->
                        </div>

                        <div class="form-row">
                            <div class="col-md-12 form-group mt-3">
                                <button class="form-control btn btn-primary" (click)="payment()" [disabled]="processing">Pay Now »</button>
                            </div>
                        </div>
                        <div class="form-row" *ngIf="notValid">
                            <div class="col-md-12 error form-group hide">
                                <div class="alert-danger alert">{{ validationMessage }}</div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
